/* ViewToggle — Visual | JSON segmented control. Visual is the read default;
 * JSON stays the edit surface (the ONE loop is untouched). */
import React from 'react';
import {
    Braces,
    Eye
} from 'lucide-react';
import './visuals.css';

export type DocView = 'visual' | 'json';

export default function ViewToggle({
    value,
    onChange
}: {
    value: DocView;
    onChange: (v: DocView) => void;
}) {
    return (
        <div className="aps-viz-seg" role="tablist" aria-label="Document view">
            <button
                type="button"
                role="tab"
                aria-selected={value === 'visual'}
                className={value === 'visual' ? 'active' : undefined}
                title="Diagram of what this document builds"
                onClick={() => onChange('visual')}
            >
                <Eye size={13} />
                Visual
            </button>
            <button
                type="button"
                role="tab"
                aria-selected={value === 'json'}
                className={value === 'json' ? 'active' : undefined}
                title="The stored JSON — copy, paste, validate, save"
                onClick={() => onChange('json')}
            >
                <Braces size={13} />
                JSON
            </button>
        </div>
    );
}
